import list from './list'
import create from './create'
import edit from './edit'

export default {
    list,
    create,
    edit,
    name: "checkinPlaces",
    key: "p_checkinPlaces",
}
